import { Typography } from "@mui/material";

import { formatPlural } from "../../../../../../utils";
import { ExplanationPopover } from "../../../../../common/ExplanationPopover/ExplanationPopover";
import { usePreviewCourse } from "../../hooks/usePreviewCourse";

export function CourseTrainingOverview() {
	const { course } = usePreviewCourse();

	if (!course) {
		return null;
	}

	const airplanes = new Set<string>();
	const totalLessons = course.lesson.length;
	let totalTeachingTime = 0;
	let totalFlightTime = 0;
	for (let i = 0; i < totalLessons; i++) {
		totalTeachingTime += course.lesson[i].teachingTime ?? 0;
		totalFlightTime += course.lesson[i].flightTime ?? 0;
		if (course.lesson[i].airplane) {
			airplanes.add(course.lesson[i].airplane);
		}
	}
	const airplaneString = Array.from(airplanes).join(", ");

	return (
		<div className="course-training-overview-container">
			<Typography className="big-text black-label">
				Training Overview
			</Typography>
			<Typography className="normal-text">{`${formatPlural(totalLessons, "Class", "Classes")}.`}</Typography>
			<Typography className="normal-text">
				{`${formatPlural((totalTeachingTime / 60).toFixed(2), "hour")} of Knowledge Development.`}
			</Typography>
			{totalFlightTime > 0 && (
				<Typography className="normal-text">
					{`${formatPlural((totalFlightTime / 60).toFixed(2), "hour")} of flight time to Develop Skill.`}
				</Typography>
			)}
			<Typography className="normal-text">
				{`${formatPlural(((totalTeachingTime + totalFlightTime) / 60).toFixed(2), "hour")} Total.`}
			</Typography>
			{airplaneString && (
				<div className="airplane-container">
					<ExplanationPopover text="Training is provided using this aircraft or simulator." />

					<Typography className="normal-text">{`Training on ${airplaneString}`}</Typography>
				</div>
			)}
		</div>
	);
}
